<!-- LANCE - Lote marcado como vendido -->
<div
  class="card-bid"
  [ngClass]="isStatus !== 'ACEITO' ? 'white' : 'green'"
  *ngIf="
    !analizing_bid &&
    animal_obj?.status === 'VENDIDO' &&
    (isStatus === 'ACEITO' || list_bids.length > 0)
  "
>
  <div class="left">
    <h3>Lote Finalizado</h3>
    <h4 *ngIf="isStatus !== 'ACEITO'">Lance Atual</h4>
    <h4 *ngIf="isStatus === 'ACEITO'">Seu lance é o vencendor!</h4>

    <div class="winning-bid">
      <i icon="check" *ngIf="isStatus === 'ACEITO'"></i>
      <h5>
        <strong>{{ attual_bid - increment | currency : 'BRL' }}</strong>
      </h5>
      <h5>
        {{
          list_bids.length > 0
            ? (list_bids[0].updated_at | date : 'dd/MM/yyyy HH:mm a')
            : ''
        }}
      </h5>
    </div>
  </div>
</div>

<!-- LANCE - Lote fechado sem vencedor -->
<div
  class="card-bid orange center"
  *ngIf="animal_obj?.status !== 'VENDIDO' && time.seg < 0 && time.min < 0"
>
  <div class="left">
    <h4>Lote fechado!</h4>
  </div>
</div>

<!-- LANCE - Lote finalizado sem vencedor -->
<div
  class="card-bid orange"
  *ngIf="
    !analizing_bid &&
    animal_obj?.status === 'VENDIDO' &&
    animal_obj?.bids &&
    animal_obj.bids.length === 0
  "
>
  <div class="left">
    <h3>Lote finalizado</h3>
    <!-- <h4>Sem vencedor</h4> -->
  </div>
</div>

<!-- LANCE - Lote aberto para lance -->
<div
  class="card-bid orange"
  *ngIf="
    !analizing_bid &&
    animal_obj?.status !== 'VENDIDO' &&
    ['OPEN', 'REAL_TIME', 'CLOSED'].includes(bid_status)
  "
>
  <div class="left">
    <h4>Próximo Lance</h4>
    <h1>{{ next_bid | currency : 'BRL' }}</h1>
  </div>

  <div class="right">
    <!-- Lance online -->
    <button
      mat-button
      class="c_white"
      (click)="openOnlineBidPopup()"
      *ngIf="isStatus !== 'ACEITO' || user.type === 'MASTER'"
    >
      DAR LANCE
    </button>

    <!-- Timer do Leilão Online -->
    <app-stopwatch
      *ngIf="
        time.min < (opened_schedule.time_bid || 0) &&
        time.min >= 0 &&
        time.seg >= 0
      "
      [finish_date]="opened_schedule.finish_date"
      [last_bid]="animal_obj.start_bid"
      [time_bid]="opened_schedule.time_bid"
      [color]="'#ffffff'"
    ></app-stopwatch>

    <div
      *ngIf="isStatus === 'ACEITO' && user.type !== 'MASTER'"
      style="width: 100%; height: 30px"
    ></div>
  </div>
</div>

<!-- LANCE - Lance Atual -->
<div
  class="card-bid"
  [ngClass]="isStatus !== 'ACEITO' ? 'white' : 'green'"
  *ngIf="
    !analizing_bid &&
    list_bids &&
    list_bids.length > 0 &&
    !['VENDIDO'].includes(animal_obj.status) &&
    ['REAL_TIME', 'OPEN'].includes(bid_status)
  "
>
  <div class="left">
    <h4 *ngIf="isStatus !== 'ACEITO'">Lance Atual</h4>
    <h4 *ngIf="isStatus === 'ACEITO'">Seu lance esta vencendo!</h4>

    <div class="winning-bid">
      <i icon="check" *ngIf="isStatus === 'ACEITO'"></i>
      <h5>
        <strong>{{ list_bids[0].value | currency : 'BRL' }}</strong>
      </h5>
      <h5>{{ list_bids[0].updated_at | date : 'dd/MM/yyyy HH:mm a' }}</h5>
    </div>
  </div>
</div>
